import {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import {TimeslotsState} from '../stateTypes';
import {actions} from '../actions';

export const extendWithChildReservationsReducers = (builder: ActionReducerMapBuilder<TimeslotsState>) => {
  builder
    .addCase(actions.fetchWorkspaceReservationChildren.pending, (state, action) => {
      const entry = state.childReservations[action.meta.arg.workspaceReservationId];
      state.childReservations[action.meta.arg.workspaceReservationId] = {
        data: entry?.data ?? null,
        status: 'pending',
        requestId: action.meta.requestId,
      };
    })
    .addCase(actions.fetchWorkspaceReservationChildren.fulfilled, (state, action) => {
      state.childReservations[action.meta.arg.workspaceReservationId] = {
        data: action.payload,
        status: 'fulfilled',
      };
    })
    .addCase(actions.fetchWorkspaceReservationChildren.rejected, (state, action) => {
      state.childReservations[action.meta.arg.workspaceReservationId] = {
        data: null,
        errorMessage: action.error.message ?? 'Something went wrong loading child reservations',
        status: 'rejected',
      };
    });
};
